import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentSchedule = new CRUD('tournament-schedule', 'superior-judge')

export default Object.assign(
    tournamentSchedule,
    {
        reducers: {
            ...tournamentSchedule.reducers
        },

        progress: (id, type) => {
            return async (dispatch) => {
                dispatch(tournamentSchedule.slice.actions.startLoading());
                try {
                    return axios.get(`/superior-judge/tournament-schedule/${id}/progress/${type}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        recalculate: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-schedule/${id}/recalculate`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        reorderNumbers: (id) => {
            return async (dispatch) => {
                dispatch(tournamentSchedule.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-schedule/${id}/reorder-numbers`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        reset: (id) => {
            return async (dispatch) => {
                dispatch(tournamentSchedule.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-schedule/${id}/reset`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        insertInto: (id, type, position) => {
            return async (dispatch) => {
                dispatch(tournamentSchedule.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-schedule/${id}/insert/${type}/into/${position}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        insertParticipant: (id, id_participant, position) => {
            return async (dispatch) => {
                dispatch(tournamentSchedule.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-schedule/${id}/insert-participant/${id_participant}/into/${position}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        appendParticipant: (id, id_participant) => {
            return async (dispatch) => {
                dispatch(tournamentSchedule.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-schedule/${id}/append-participant/${id_participant}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
